// extracted by mini-css-extract-plugin
export default {"container":"Rarities_container__lbGAa","rarity":"Rarities_rarity__6qOaM","loading":"Rarities_loading__qKfmC"};